
import axios from 'axios';
import qs from 'qs';
import { Message } from 'view-design';
import store from '@/store/index';
// import router from  '@/router';
// 工具函数
import { pathRewrite } from '@/common/utils';
// 配置文件
import configEnv from '@/config';


const http = {};
axios.defaults.timeout = 60000;
axios.defaults.baseURL = configEnv.baseURL || '';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// request 拦截器
axios.interceptors.request.use(
  config => {
    // Spin.show();
    // 请求路径重写
    config.url = pathRewrite(configEnv.pathRewrite, config.url);
    // config.withCredentials = true // 允许携带token ,这个是解决跨域产生的相关问题
    // config.timeout = 6000;

    const userInfo = store.state.user.userInfo;
    if (userInfo && userInfo.token) {
      config.headers['access-token'] = userInfo.token;
      // config.headers['u-id'] = 2357; // 暂时测试时用到
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);
let loginRouteRepeat = false;
// response拦截
axios.interceptors.response.use(
  response => {
    // Spin.hide();
    // if(!response.data.success){
    //     Message.error(response.data.message||'请求出错')
    // }

    if ([1000004005,1000004401].includes(response.data.code)) {
      // router.push('/login');
      // 通知父级更新token
      // if (window.self !== window.top) {
      //   window.top.postMessage(JSON.stringify({ type: 'refreshToken'}), '*');
      // } else {
      //   // 防止登录路由地址跳转相同
      //   if (!loginRouteRepeat){
      //     loginRouteRepeat = true;
      //     window.$vm.$router.push('/login');
      //   }
      // }
      // 防止登录路由地址跳转相同
      if (!loginRouteRepeat){
        loginRouteRepeat = true;
        // window.$vm.$router.push('/login');
        // 清除缓存
        store.commit('clearUserInfo');
        // 去用户中心登录
        // 登陆完成之后会在重定向回来，并在路径后面拼接token
        // const redirectUrl = delParam({
        //   key: 'redirectUrl',
        //   url: window.location.href,
        // });
        window.location.href = `${configEnv.userDomian}/usercenter/login?redirectUrl=${encodeURIComponent(window.location.href)}`;
        return;
      }
    } else {
      loginRouteRepeat = false;
    }

    return response;
  },
  error => {
    // Spin.hide();
    Message.error(error.message || '请求出错');
    return Promise.reject(error);
  },
);
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.get = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios.get(url, { params })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};

/**
 * 封装post方法
 * @param url
 * @param data
 * @returns {Promise}
 */
http.post = (url, params = {}) => {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  if (Object.prototype.toString.call(params) !== '[object FormData]') {
    // 非文件上传时
    params = qs.stringify(
      params,
      {
        filter: (key, value) => {
          return typeof value === 'undefined' || (!value && typeof value != 'undefined' && value != 0) ? '' : value;
        },
      },
    );
  }

  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};
http.postJson = (url, params = {}) => {
  axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
};
http.postBlob = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url,
      params,
      responseType: 'blob',
    }).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err);
    });
  });
};
http.getBlob = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      params,
      responseType: 'blob',
    }).then(response => {
      resolve(response.data);
    }).catch(err => {
      reject(err);
    });
  });
};
export default http;
